var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3514 6.92309L6.92325 6.92329L6.92313 10.3514C6.92303 10.8614 6.50989 11.2745 5.9999 11.2746C5.74513 11.2746 5.51438 11.1713 5.34745 11.0044C5.18024 10.8372 5.07686 10.6065 5.07706 10.3518L5.07699 6.92312L1.64848 6.92317C1.39373 6.92318 1.16296 6.8199 0.995889 6.65283C0.828863 6.4858 0.725596 6.25525 0.725597 6.00028C0.725583 5.4904 1.13874 5.07724 1.64883 5.07704L5.07687 5.07688L5.07701 1.64868C5.07701 1.13878 5.49025 0.725541 6.00014 0.725538C6.5098 0.725682 6.92279 1.13867 6.92303 1.64842L6.92316 5.07692L10.3515 5.07692C10.8613 5.07721 11.2744 5.49025 11.2745 5.99985C11.2746 6.50985 10.8613 6.92309 10.3514 6.92309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b37e9174729630fdccec536caeabb180.svg";
export { ForwardRef as ReactComponent };